<template>
  <c-data-filters>
    <template #basic>
      <label class="sr-only">Search</label>

      <c-input type="text" :value="filters.search" @input="updateSearch">
        <i slot="prepend" class="fal fa-search" />
      </c-input>
    </template>

    <div class="row">
      <div class="col-lg-4 mb-3 flex-grow-1">
        <div class="mb-3">
          <label>Search</label>

          <c-input type="text" :value="filters.search" @input="updateSearch">
            <i slot="prepend" class="fal fa-search" />
          </c-input>
        </div>
      </div>
      <div class="col-12 col-lg-4 col-xl-4">
        <div class="mb-3">
          <label>Status</label>

          <c-input
            as="multiselect"
            placeholder
            :options="statusOptions"
            :searchable="false"
            :preselect-first="true"
            :show-labels="false"
            :allow-empty="false"
            label="name"
            v-model="status"
          >
          </c-input>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label>Media Owner Screen Tag</label>

          <media-owner-screen-tag-select-generic holder="All" v-model="selectedMediaOwnerScreenTags" @input="updateMediaOwnerScreenTags"/>
        </div>
      </div>
    </div>
  </c-data-filters>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import MediaOwnerScreenTagSelectGeneric from '@/components/forms/MediaOwnerScreenTagSelectGeneric.vue'

export default {
  mixins: [useQueryParamFilters()],

  components: {
    MediaOwnerScreenTagSelectGeneric,
  },

  data () {
    return {
      filters: {
        search: null,
        status: 'all',
        tags: [],
        mediaOwnerScreenTags: [],
      },
      statusOptions: [
        { name: 'All', value: 'all' },
        { name: 'No Issues', value: 1 },
        { name: 'Communication Error', value: 2 },
        { name: 'Fault', value: 4 }
      ],
      selectedTags: [],
      selectedMediaOwnerScreenTags: [],
    }
  },

  computed: {
    status: {
      get () {
        return this.statusOptions.find(({ value }) => value === this.filters.status)
      },

      set ({ value }) {
        this.filters.status = value
      }
    },
  },

  methods: {
    updateSearch: debounce(function (value) {
      this.filters.search = value
    }, 500),

    updateTags () {
      this.filters.tags = this.selectedTags.map(({ id }) => id)
    },
    updateMediaOwnerScreenTags () {
      this.filters.mediaOwnerScreenTags = this.selectedMediaOwnerScreenTags.map(({ id }) => id)
    }
  }
}
</script>
